<template>
  <b-modal :title="title" :size="size" centered id="modal-change-profile-pic">
    <div slot="default">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-12">
              <img
                v-if="isShowEditImage"
                :src="componentModel.urlImg"
                class="rounded ml-5 align-items-center justify-content-between"
              />
              <img
                v-if="!isShowEditImage && componentModel.image"
                :src="componentModel.image_url"
                class="rounded"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-12">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text bg-transparent"
                    ><i class="bx bxs-folder-open"></i
                  ></span>
                </div>
                <b-form-file
                  placeholder="Choose file"
                  accept="image/*"
                  v-on:change="importImage($event)"
                  v-model="componentModel.file"
                ></b-form-file>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer">
      <b-button class="mt-3" variant="outline-primary" block @click="onApply"
        >Apply</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import { eventBus } from '@/main.js'
import filecloudService from '@/helpers/service/filecloud-service'
import userService from '@/helpers/service/user-provider'
import { authMethods } from '@/state/helpers'
export default {
  name: 'ChangeProfilePictureModalComponent',
  components: {},
  props: {
    title: { type: String, default: 'Select Profile Picture' },
    size: { type: String, default: 'md' },
    user_id: { type: String, default: '' },
  },
  data() {
    return {
      pattern: 'info',
      remark: '',
      bodyText: '',
      isShowEditImage: false,
      componentModel: {
        image_url: null,
        urlImg: '',
        file: null,
        originalImg: null,
        thumpImg: null,
      },
    }
  },
  mounted() {
    eventBus.$on('info-modal', text => {
      this.$refs.modal.show()
      this.bodyText = text
    })
  },
  beforeDestroy() {
    eventBus.$off('info-modal', () => {
      this.$refs.modal.hide()
      this.bodyText = ''
    })
  },
  methods: {
    ...authMethods,
    async onApply() {
      var isUploadSucess = await this.checkUploadImage()
      if (isUploadSucess) {
        var body = {
          photo_url: this.componentModel.image_url,
        }
        let result = await userService.updateUserPhotoAsync(this.user_id, body)
        if (result.status && result.status === 204) {
          this.getMe()
          this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
          this.$bvModal.hide('modal-change-profile-pic')
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async getMe() {
      let params = new URLSearchParams()
      params.append('no-cache', '')
      let result = await userService.getUserMeAsync(params)
      if (result.status === 200) {
        var x = result.data
        var uniq = '' + new Date().getTime()
        x.photo = x.photo + '?v=' + uniq
        this.setUserInfo(x)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async checkUploadImage() {
      var checkUpload = true
      var isUploadError = false
      if (
        this.componentModel.originalImg !== null &&
        this.componentModel.originalImg !== undefined
      ) {
        let dataOriginal = new FormData()
        dataOriginal.append(
          'file',
          this.componentModel.originalImg,
          `${this.user_id}.png`
        )
        // var uniq = '' + new Date().getTime()
        dataOriginal.append(
          'bucket',
          `${process.env.VUE_APP_BUCKET_USER_IMAGE}`
        )
        dataOriginal.append('path', `users_pic`)
        dataOriginal.append('key', `${this.user_id}.png`)
        dataOriginal.append('content_description', `pim user profile picture`)
        dataOriginal.append('is_upsert', true)
        let resultUploadOriginal = await filecloudService.uploadImageAsync(
          dataOriginal
        )
        if (resultUploadOriginal.status === 201) {
          this.componentModel.image_url = resultUploadOriginal.data.content_url
          checkUpload = true
          eventBus.$emit('changeLoadingState', false)
        } else {
          checkUpload = false
          isUploadError = true
          this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload รูปภาพ')
        }
      }
      return checkUpload && isUploadError === false
    },
    importImage(e) {
      var vm = this
      const file = e.target.files[0]
      if (file.type.match(/image.*/)) {
        var reader = new FileReader()
        reader.onload = function(readerEvent) {
          var image = new Image()
          image.onload = function(imageEvent) {
            let _point = 1
            if (image.width > 1500) _point = 0.15
            else if (image.width > 1000) _point = 0.2
            else if (image.width > 500) _point = 0.5
            else if (image.width > 250) _point = 0.8

            var canvas = document.createElement('canvas')
            canvas.width = image.width * _point
            canvas.height = image.height * _point
            canvas.imageSmoothingQuality = 'high'
            canvas
              .getContext('2d')
              .drawImage(image, 0, 0, canvas.width, canvas.height)
            var dataUrl = canvas.toDataURL('image/png')
            var resizedImage = vm.dataURLToBlob(dataUrl)

            // vm.componentModel.urlImg = dataUrl
            vm.$set(vm.componentModel, 'urlImg', dataUrl)
            vm.componentModel.originalImg = resizedImage
            vm.isShowEditImage = true
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    dataURLToBlob(dataURL) {
      let BASE64_MARKER = ';base64,'
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        let parts = dataURL.split(',')
        let contentType = parts[0].split(':')[1]
        let raw = parts[1]

        return new Blob([raw], { type: contentType })
      }

      let parts = dataURL.split(BASE64_MARKER)
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      return new Blob([uInt8Array], { type: contentType })
    },
  },
}
</script>
<style></style>
